import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
// import Bowser from 'bowser';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Item from './item';
import { dealTime } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/formatDate';

import styles from './index.css';

/* eslint-disable */
/**
 * 定义 content 组件
 */
class Content extends PureComponent {
    static propTypes = {
        contentData: PropTypes.array,
    };

    state = {
        contentData: [...this.props.contentData],
        todayChinese: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (props.contentData !== state.contentData) {
            return {
                contentData: props.contentData,
            };
        }

        return null;
    }

    getPageTime = () => {
        const { contentData } = this.state;
        let todayStr = '';

        for (let i = 0, len = contentData.length; i < len; i++) {
            if (contentData[i].newsTime) {
                todayStr = contentData[i].newsTime;
                break;
            }
            todayStr = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`;
        }

        const curToday = new Date(todayStr);

        const month = curToday.getMonth() + 1;
        const date = curToday.getDate();
        const dayStr = dealTime(curToday.getDay());

        const todayChinese = `${month}月${date}日 ${dayStr}`;

        this.setState({
            todayChinese,
        });
    };

    componentDidMount() {
        this.getPageTime();
    }
    componentWillUnmount() {}

    render() {
        let { contentData, todayChinese } = this.state;
        const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

        contentData = contentData.map(item => {
            if (item.url && isVideoShare) {
                item.url = `https://ishare.ifeng.com/c/vs/${item.url.split('/').pop()}`;
            }

            return item;
        });

        return (
            <div className={styles.newsWarp}>
                <div className={styles.todayTime}>
                    <span className={styles.chineseTime}>{todayChinese}</span>
                </div>

                {contentData.map((item, index) => {
                    if (item.type === 'ad') {
                        return <div key={index} ref={item.ref} />;
                    } else {
                        return <Item key={index} item={item} index={index} />;
                    }
                })}
            </div>
        );
    }
}

export default errorBoundary(Content);
